import React, { useState, useEffect, useContext } from 'react';
import { Row, Col, Container } from 'reactstrap';
import { axios } from '../../services/ServiceUtils';
import Title from '../../components/Title';
import { SitemapItem } from './components/SitemapItem';
import { SitemapBox } from './style';
import LanguageContext from '../../contexts/LanguageContext';

const Sitemap = () => {
  const [dataSitemap, setDataSitemap] = useState([]);
  const { language } = useContext(LanguageContext);

  useEffect(() => {
    document.title="DFS | Sitemap"
    axios
      .get('api/sitemap', {
        headers: {
          'Content-Language': `${language.locale}`,
        },
      })
      .then(result => {
        setDataSitemap(result.data);
      })
      .catch(e => {
        // eslint-disable-next-line no-console
        console.error('request error', e);
      });
  }, [language]);

  return (
    <Container>
      <SitemapBox>
        <Row>
          <Col>
            <Title className="mt-2 mt-sm-4 mb-2 mb-sm-3">{dataSitemap.title ?? 'Sitemap'}</Title>
          </Col>
        </Row>
        {dataSitemap.mapItems ? (
          <Row>
            {dataSitemap.mapItems.map((item, idx) => (
              <SitemapItem key={idx} /* key={item.order} */ data={item} /* subsection={item.subsection} */ />
            ))}
          </Row>
        ) : null}
      </SitemapBox>
    </Container>
  );
};

export default Sitemap;
